import { useMemo } from 'react';
import useSafeArray from './useSafeArray';
import { isTotalSummaryLine } from '../utils/lifecarePlanUtils';

// normalizes raw summary lines and pre-computes the isTotal flag so the
// summary component stays dumb (markup only)
const useLifecareStudioSummary = ({ summaryLines }) => {
  const safeLines = useSafeArray(summaryLines);
  return useMemo(
    () => safeLines.map((line, index) => ({
      line,
      index,
      isTotal: isTotalSummaryLine(line),
    })),
    [safeLines]
  );
};

export default useLifecareStudioSummary;
